export default __webpack_public_path__ + "static/media/spaceShipC1.3966a21a.webp";